import { markRaw } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import {
  CompanyNameAvatarColumnFragmentDoc,
  CompanyNameAvatarColumnFragment,
} from '@/gql/graphql'
import CompanyNameAvatarColumn from '@/components/GraphqlDataTable/columns/Company/CompanyNameAvatarColumn.vue'
import { ColumnMaps } from '@/components/GraphqlDataTable/columns/types'

const columns: ColumnMaps = {
  CompanyNameAvatarColumn: {
    fragment: CompanyNameAvatarColumnFragmentDoc,
    component: markRaw(CompanyNameAvatarColumn),
    columnDef: {
      title: $t('Company'),
      key: 'company.id',
      renderUsing: {
        component: markRaw(CompanyNameAvatarColumn),
        componentProps: (row) => ({ row }),
      },
    },
    dataDescriber: [
      {
        title: 'Company name',
        extraction: (row: CompanyNameAvatarColumnFragment) => row.name ?? '',
      },
    ],
  },
}

export default columns
